import { FeatureFlags } from '@tools/shared';

type FlagDefaultValue = any;
type FlagNameToDefaultValueMap = {
  [flagName: string]: FlagDefaultValue;
};

const FLAGS_DEFAULT_VALUE = false;
const flagNames = Object.values(FeatureFlags);
const nameValueEntries = flagNames.map((name) => [name, FLAGS_DEFAULT_VALUE]);

export const flagMap: FlagNameToDefaultValueMap =
  Object.fromEntries(nameValueEntries);
